var EHDI = EHDI || Object.create(null);

EHDI.popup = EHDI.popup || Object.create(null);

EHDI.popup.PlaquePopup = function( fishName, fishWeight, fishAsset ) {
    EHDI.aka.Container.call(this);
    
    var _this = this;
    
    var _overlay,
        _radial,
        _radialTween,
        _plaque,
        _labelContainer,
        _label,
        _fish, 
        _fishName = fishName,
        _fishWeight = fishWeight,
        _fishAsset = fishAsset;
    
    var _backButton;
    
    this.popUpWillAppear = function() {
        _overlay = new EHDI.aka.Sprite(EHDI.displays.TextureRectangle(0x00000, EHDI.screen.stageWidth, EHDI.screen.stageHeight));
        _overlay.anchor.set(0.5, 0.5);
        _overlay.alpha = 0;
        _overlay.interactive = true;
        _this.addChild( _overlay );
        
        _radial = new EHDI.aka.Sprite( EHDI.Assets.images[ "WB_ingame_starburst" ] );
        _radial.anchor.set( 0.5, 0.5 );
        _radial.alpha = 0;
        _this.addChild( _radial );
        _radialTween = TweenMax.to( _radial, 8, { rotation: 2 * Math.PI, ease:Linear.easeNone, repeat: -1 } );
        
        _plaque = new EHDI.aka.Sprite( EHDI.Assets.images[ "con_trophy" ] );
        _plaque.anchor.set( 0.5, 0.5 );
        _this.addChild( _plaque );
        
        _fish = new EHDI.aka.Sprite( EHDI.Assets.images[ _fishAsset ] );
        _fish.rotation = -Math.PI/2;
        _fish.anchor.set( 0.5, 0.5 );
        _fish.position.y = _plaque.height * -0.16;
        _plaque.addChild( _fish );
        
        _labelContainer = new EHDI.aka.Sprite( EHDI.Assets.images[ "trophy_gold" ] );
        _labelContainer.anchor.set( 0.5, 0.5 );
        _labelContainer.position.y = _plaque.height * 0.27;
        _plaque.addChild( _labelContainer );
        
        var labelText = EHDI.localization.strings["plaque"].content;
        labelText = labelText.replace( "[name]", _fishName );
        labelText = labelText.replace( "[weight]", _fishWeight );
        
        _label = new EHDI.aka.PixiText( labelText, {
            fontFamily: "nuevastd-bold", 
            fontSize: EHDI.localization.strings["plaque"].size, 
            align: 'center', 
            fill: '#592E0E' 
        });
        _label.anchor.set( 0.5, 0.5 );
        _labelContainer.addChild( _label );
        
        _backButton = new EHDI.displays.Button(EHDI.Assets.images["btn_back"], null, null, null, 0.8);
        _backButton.position.set(-EHDI.screen.viewWidth * 0.425, -EHDI.screen.viewHeight * 0.375);
        _backButton.setOnClickFunction( closePlaque );
        _this.addChild( _backButton );
    }
    
    this.popUpDidAppear = function() {
        _radial.alpha = 1;
        _overlay.alpha = 0.5;
    }
    
    this.popUpDidDisappear = function() {
        EHDI.GAME.gameScene.pauseManager.isPaused = false;
    }
    
    var closePlaque = function() {
        EHDI.GAME.soundManager.playSFX("button_01");
        _backButton.disable( true );
        _radial.alpha = 0;
        _overlay.alpha = 0.0;
        EHDI.GAME.sceneManager.popPopUp({y : new EHDI.scene.TransitionParameter(0, -EHDI.screen.stageHeight), duration : 0.2});
    }
    
    this.dispose = function() {
        _radialTween.kill();
    }
}

EHDI.popup.PlaquePopup.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.popup.PlaquePopup.prototype.destroy = function() {
    this.dispose();
    EHDI.aka.Container.prototype.destroy.apply(this, arguments);
}